import api from './client';

// Recurring Payments Coverage census (services/recurring_payments_coverage.py,
// routes/admin_recurring_payments_coverage.py): read-only vendor x month grid,
// classified from existing data. 202+JobStore, same shape as every other
// out-of-band diagnostics card -- poll job-status/job-latest for progress
// and the terminal result via components/admin/JobPollingPanel.jsx.
export const recurringPaymentsCoverageAPI = {
  start: () => api.post('/admin/diagnostics/recurring-payments-coverage/start'),
  jobStatus: (jobId) => api.get(`/admin/diagnostics/recurring-payments-coverage/job-status/${jobId}`),
  jobLatest: () => api.get('/admin/diagnostics/recurring-payments-coverage/job-latest'),
};
